export const isSticker = (messageText: string): boolean => {
  const stickerRegex = /^(u[dD][0-9a-fA-F]{3,4})+$/;
  return stickerRegex.test(messageText);
};

export const unicodeToEmoji = (unicode: string): string => {
  const codePoints = unicode
    .split(/u(d[0-9a-f]{3,4})/i)
    .filter(Boolean)
    .map((u) => parseInt(u, 16));
  return String.fromCodePoint(...codePoints);
};
